<template>
    <div v-if="isLoading">
        Loading...
    </div>
    <div v-else>
        <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
        <v-dialog v-model="CRUDdialog" max-width="600px">
            <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
            </template> -->
            <v-card>
                <v-card-title>
                    {{ isEdit ? $t('setupcompany.editcompany') : $t('setupcompany.addcompany') }}
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="9" sm="9" md="9" class="mt-n4">
                                <v-autocomplete outlined :label="$t('columns.company')" type="text" :items="companyList"
                                    hide-selected item-value="value" item-text="text" v-model="formData.companyId"
                                    @change="changeCompanyHandler(formData.companyId)" dense clearable></v-autocomplete>
                            </v-col>

                            <v-col cols="3" sm="3" md="3" class="mt-n4">
                                <v-text-field outlined background-color="#ffeab2" readonly :label="$t('columns.code')"
                                    type="text" v-model="formData.companyCode" dense></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{ errMsg }}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeCRUDInput">
                        {{ $t('button.cancel') }}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="saveCRUDInput">
                        {{ $t('button.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div style="overflow-x: auto; width: 100%;">
        <v-data-table :headers="this.parentObject.tabHeader" :items="detailItemList" class="elavation-1"
:sort-by="['code']">
            <template v-slot:[`item.action`]="{ item }">
                <template v-if="!notAllowToEdit">
                    <v-icon small class="mr-2" @click="modifyItemHandler(item)">
                        mdi-pen
                    </v-icon>
                    <v-icon small class="ml-3 mr-2" @click="deleteItemHandler(item)">
                        mdi-delete
                    </v-icon>
                </template>
            </template>
        </v-data-table>
        </div>
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }" v-on:closeError="isErr = $event" />
        </div>
        <div v-if="isConfirm">
            <app-confirm v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
            }" v-on:confirm="deleteItemHandlerAction" v-on:cancelConfirm="isConfirm = !isConfirm" />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
// import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                // percentage: value => !(value < 0 || value > 100) || this.$t('reportsparam.valueonetohundred'),
                // factor: value => value > 0 || "The value must be greater than 0",
            },

            CRUDdialog: false,

            formData: {
                id: null,
                ackRecordId: this.parentObject.ackRecordId,

                companyId: null,
                companyCode: null,
                companyName: null,

                rectimestamp: null,
                stamp: 0,
                updatedby: this.$store.getters.userId,
            },

            detailItemList: this.parentObject.detailItemList || [],

            companyList: [],
            companyFullItem: [],

            notAllowToEdit: this.parentObject.notAllowToEdit,

            isLoading: true,
            isEdit: false,//default add new item, for the title
            isErr: false,
            errMsg: '',
            isConfirm: false,
            messageConfirm: '',
            selectedItem: null,
        }
    },

    methods: {
        newItem() {
            this.isExisting = false;
            this.modify = false;
            this.resetSelections();
        },
        async loadCompanyOption() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', {
                    url: "/company/all/"
                });

                vm.companyFullItem = res.data.rec;
                vm.companyList = []; // Clear before populating
                for (let i = 0; i < vm.companyFullItem.length; i++) {
                    vm.companyList.push({
                        text: vm.companyFullItem[i].compnyname,
                        value: vm.companyFullItem[i].id,
                        code: vm.companyFullItem[i].compnycode,
                    });
                }
            } catch (err) {
                vm.errMsg = err;
                console.error("❌ Error loading company option", err);
            }
        },

        async changeCompanyHandler(id) {
            let item = this.companyFullItem.find(item => item.id == id);
            if (item == null) { // not found,  or after clearable 
                this.formData.companyCode = '';
            }
            else {
                this.formData.companyCode = item.compnycode;
            }
        },

        async modifyItemHandler(item) {
            this.isEdit = true;
            this.formData = { ...item };// copy the data, not set a reference point like below
            // this.formData = item; // this is an bad example setting reference point to the data
            // and it may cause problem because we directly editing data in the list 
            // even without save

            await this.changeCompanyHandler(item.companyId);
            this.CRUDdialog = true;
            // console.log("modify item:",  this.formData);
        },

        deleteItemHandler(item) {
            this.messageConfirm = this.$t('pmrewardrecord.deleterowdataconfirm');
            this.selectedItem = item;
            this.isConfirm = true;
        },

        async deleteItemHandlerAction() {
            const vm = this;

            if (!this.selectedItem) {
                console.error("❌ No item selected for deletion!");
                return;
            }

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                vm.isErr = true;
                vm.errMsg = this.$t('vdatatable.accessnotgranted');
                console.error("❌ No permission to delete");
                return false;
            }

            try {
                let itemIndex = this.detailItemList.indexOf(this.selectedItem);
                this.detailItemList.splice(itemIndex, 1);

                await this.resetSelections();

                this.$emit("input", this.detailItemList);
                this.CRUDdialog = false;
                this.isEdit = false;
                vm.selectedItem = null;  // 🔹 Clear after deletion
            } catch (err) {
                vm.isErr = true;
                vm.errMsg = err + " Something went wrong, Please refresh this page";
                console.error("❌ Error during deletion:", err);
            } finally {
                vm.isConfirm = false;  // 🔹 Close confirmation dialog
            }
        },

        async saveCRUDInput() {
            this.isErr = false;
            this.errMsg = '';
            // ✅ Basic validation
            // this.formData.ackRecordId 
            // -> as a newly created record id is not here yet
            // so we cannot check against parent id here (for new record)
            if (!this.formData.companyId) {
                this.isErr = true;
                this.errMsg = this.$t('payeeinputprocess.payeeinputmsg3');
                return;
            }

            try {
                if (this.isEdit) {
                    // ✅ Editing existing record (record with ID)
                    const editIndex = this.detailItemList.findIndex(
                        item => item.id === this.formData.id
                    );

                    if (editIndex === -1) {
                        this.isErr = true;
                        this.errMsg = this.$t('acknowledgement.editnotfoundmsg') || 'Record not found for editing.';
                        return;
                    }
                    // console.log("Editing item at index:", editIndex);

                    // ✅ Prevent duplicate companyId, excluding the record being edited
                    const duplicate = this.detailItemList.some(
                        (item, idx) =>
                            idx !== editIndex &&
                            item.companyId === this.formData.companyId
                    );
                    // console.log("Duplicate check result:", duplicate);
                    // console.log("Current detailItemList:", this.detailItemList);
                    if (duplicate) {
                        this.isErr = true;
                        this.errMsg = this.$t('acknowledgement.duplicatecompanymsg');
                        return;
                    }

                    //set the name based on selected id
                    const selectedCompany = this.companyList.find(
                        c => c.value === this.formData.companyId
                    );

                    if (selectedCompany) {
                        this.formData.companyName = selectedCompany.text;
                    } else {
                        this.formData.companyName = null;
                    }

                    // ✅ Apply update safely to keep Vue reactivity
                    this.$set(this.detailItemList, editIndex, { ...this.formData });

                } else {
                    // ✅ Adding new record (no ID yet)
                    const duplicate = this.detailItemList.some(
                        item => item.companyId === this.formData.companyId
                    );
                    // console.log("new")
                    // console.log("Duplicate check result for new record:", duplicate);
                    // console.log("Current detailItemList:", this.detailItemList);
                    if (duplicate) {
                        this.isErr = true;
                        this.errMsg = this.$t('acknowledgement.duplicatecompanymsg');
                        return;
                    }

                    //set the name based on selected id
                    const selectedCompany = this.companyList.find(
                        c => c.value === this.formData.companyId
                    );

                    if (selectedCompany) {
                        this.formData.companyName = selectedCompany.text;
                    } else {
                        this.formData.companyName = null;
                    }

                    const newRecord = {
                        ...this.formData,
                        id: null, // optional, helps identify new unsaved records
                    };

                    this.detailItemList.push(newRecord);
                }

                // ✅ Cleanup
                await this.resetSelections();

                // send the latest record to form
                this.$emit("input", this.detailItemList);
                this.CRUDdialog = false;
                this.isEdit = false;

            } catch (err) {
                console.error('❌ Error in saveCRUDInput:', err);
                this.isErr = true;
                this.errMsg = err?.message || "Something is wrong in the CRUD save";
            }
        },

        async closeCRUDInput() {
            this.CRUDdialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            await this.resetSelections();


        },

        async resetSelections() {
            this.formData = {
                id: null,
                ackRecordId: this.parentObject.ackRecordId,
                companyId: null,
                companyCode: null,
                companyName: null,
                rectimestamp: null,
                stamp: 0,
                updatedby: this.$store.getters.userId,
            };
        },

        openDialog() {
            this.isEdit = false;
            this.isErr = false;
            if (this.notAllowToEdit) {
                this.isErr = true;
                this.errMsg = "The Acknowledgement Record is already out, please suspend and try again";
                return;
            }
            else {
                this.CRUDdialog = true;
            }

        },
    },

    async mounted() {
        try {
            this.isLoading = true;

            await this.loadCompanyOption();
            this.isLoading = false;
            // console.log("is my parent not allow to edit: ", this.notAllowToEdit);
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },
}
</script>